import * as React from 'react';
import { motion, useAnimation } from 'framer-motion';

const defaultTransition = { duration: 0.3, ease: 'easeInOut' };

interface IconProps {
	isHovered: boolean;
}

export function UsersIcon({ isHovered }: IconProps) {
	const controls = useAnimation();

	React.useEffect(() => {
		void controls.start(isHovered ? 'animate' : 'normal');
	}, [isHovered, controls]);

	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			>
				<motion.path
					d='M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2'
					variants={{
						normal: { translateX: 0 },
						animate: { translateX: -2 },
					}}
					animate={controls}
					transition={defaultTransition}
				/>
				<motion.circle
					cx='9'
					cy='7'
					r='4'
					variants={{
						normal: { scale: 1 },
						animate: { scale: 1.1 },
					}}
					animate={controls}
					transition={defaultTransition}
				/>
				<motion.path
					d='M22 21v-2a4 4 0 0 0-3-3.87'
					variants={{
						normal: { translateX: 0 },
						animate: { translateX: 2 },
					}}
					animate={controls}
					transition={defaultTransition}
				/>
				<motion.path
					d='M16 3.13a4 4 0 0 1 0 7.75'
					variants={{
						normal: { translateX: 0 },
						animate: { translateX: 2 },
					}}
					animate={controls}
					transition={defaultTransition}
				/>
			</svg>
		</div>
	);
}
